import { app } from '../../../../../app';
import { Controller } from './add-shared-authenticator.controller';

app.component('companySharingCenterSharedAuthenticatorsAdd', {
    bindings: {
		publicServicesWithSsoAnd2FA$:'<',
        companyId: '<',
        copyAccount: '<',
    },
    controller: Controller,
    templateUrl: require('./add-shared-authenticator.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.component.js